import { createFileRoute } from "@tanstack/react-router";
import { AssetTypeRulesSection } from "./fullRules";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/assetTypes/$assetTypeId/rules",
)({
	component: OrgAssetTypeRulesTab,
});

function OrgAssetTypeRulesTab() {
	return (
		<div className="px-5 pb-5">
			<AssetTypeRulesSection stayOnRoute />
		</div>
	);
}
